import React, { FC } from 'react';
import { Box, DialogContent, styled, useTheme } from '@mui/material';
import ThemeTypography from 'DesignSystem/Primitives/Typography/ThemeTypography';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import useDialog from 'hooks/useDialog';
import { DialogDefault } from 'DesignSystem';
import { IDefaultDialogProps } from 'types/dialog.types';
import SeparatorLine from 'Components/SeparatorLine';
import Icon from 'DesignSystem/Primitives/Icon/Icon';

interface IPartnerSelectDecisionDialogProps extends IDefaultDialogProps {
  connectToCompanyId?: string;
}

const ContentWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
}));

const PartnerSelectDecisionDialog: FC<IPartnerSelectDecisionDialogProps> = ({
  onClose,
  connectToCompanyId,
  open = true,
}) => {
  const theme = useTheme();
  const { openDialog } = useDialog();

  const handleCreatePartnerManually = () => {
    openDialog({
      type: 'ADD_EDIT_PARTNER',
      props: { connectToCompanyId, skipInvitationEmail: true },
    });
    onClose?.();
  };

  const handleInvitePartner = () => {
    openDialog({ type: 'ADD_EDIT_PARTNER', props: { connectToCompanyId, enableInvite: true } });
    onClose?.();
  };

  return (
    <DialogDefault
      title="Add partner"
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth="xs"
      background="#fff"
      data-testid="partner-form-dialog"
    >
      <DialogContent>
        <ContentWrapper>
          <ThemeButton
            color="PRIMARY"
            fullWidth
            startIcon={<Icon name="invite" color="WHITE" size="large" />}
            size="large"
            onClick={handleInvitePartner}
          >
            Invite partner
          </ThemeButton>

          <Box mt={1}>
            <ThemeTypography variant="BODY_SMALL" color="GRAY">
              Allows the partner to add their own information, and for you to easily request
              information from them.
            </ThemeTypography>
          </Box>

          <SeparatorLine label="or" width="80%" backgroundColor={theme.custom.colors.offWhite} />

          <ThemeButton
            color="BLUE_ICE"
            fullWidth
            size="large"
            data-testid="add-partner-manually-btn"
            onClick={handleCreatePartnerManually}
          >
            Add partner manually
          </ThemeButton>

          <Box mt={1}>
            <ThemeTypography variant="BODY_SMALL" color="GRAY">
              You can still invite your partner later on.
            </ThemeTypography>
          </Box>
        </ContentWrapper>
      </DialogContent>
    </DialogDefault>
  );
};

export default PartnerSelectDecisionDialog;
